module.exports = __webpack_public_path__ + "img/avatar_镖师.44ed3e97.jpg";